'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _assetAllocation = require('./assetAllocation.html');

var _assetAllocation2 = _interopRequireDefault(_assetAllocation);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var assetAllocation = {
    bindings: {
        investor: '='
    },
    template: _assetAllocation2.default,

    controller: function controller($scope, $ionicScrollDelegate, $element, ApiPicklist, $filter) {
        var _this = this;

        this.$ionicScrollDelegate = $ionicScrollDelegate;
        this.assetAllocations = [];
        this.apiPicklist = ApiPicklist;

        $scope.$watch(function () {
            return _this.investor.investor.assetAllocationAdditionalInfoDto;
        }, function () {
            _this.history.historyInfo = _this.investor.investor.assetAllocationAdditionalInfoDto && _this.investor.investor.assetAllocationAdditionalInfoDto.history;
        });

        this.$onInit = function () {
            _this.apiPicklist.retrieveAssetClasses().then(function (data) {
                _this.assetAllocations = data;
            });

            _this.history = {};
            _this.history.historyInfo = _this.investor.investor.assetAllocationAdditionalInfoDto && _this.investor.investor.assetAllocationAdditionalInfoDto.history;

            _this.assetData = angular.copy(_this.investor.investor.investor.assetAllocations);
            if (_this.assetData.length > 0) {
                _this.assetData[0].highlight = true;
                _this.assetObject = _this.assetData[0];
                _this.setChartData(_this.assetObject);
            }
        };

        this.getTooltiplabel = function (tooltipItem, data) {
            return data.labels[tooltipItem.index] + ': ' + data.datasets[0].data[tooltipItem.index] + '%';
        };
        this.setChartData = function (assetObject) {
            _this.assestChartTwo.allocationData = [];
            _this.assestChartTwo.allocationData.push(assetObject.chartTwo.alternatives);
            _this.assestChartTwo.allocationData.push(assetObject.chartTwo.realEstate);
            _this.assestChartTwo.allocationData.push(assetObject.chartTwo.bondInvestments);
            _this.assestChartTwo.allocationData.push(assetObject.chartTwo.loans);
            _this.assestChartTwo.allocationData.push(assetObject.chartTwo.equitites);
            _this.assestChartTwo.allocationData.push(assetObject.chartTwo.privateEquity);
            _this.assestChartTwo.allocationData.push(assetObject.chartTwo.privateDebt);
            _this.assestChartTwo.allocationData.push(assetObject.chartTwo.hedgeFunds);
            _this.assestChartTwo.allocationData.push(assetObject.chartTwo.realAssets);
            _this.assestChartTwo.allocationData.push(assetObject.chartTwo.miscellaneousMixedInvestments);
            _this.assestChartTwo.allocationData.push(assetObject.chartTwo.cashAndEquivalents);
            _this.assestChartTwo.allocationData.push(assetObject.chartTwo.investmentInAffiliateCompanies);
            _this.assestChartTwo.allocationData.push(assetObject.chartTwo.insuranceContracts);
            _this.assestChartOne.allocationData = [];
            _this.assestChartOne.allocationData.push(assetObject.chartOne.shareHoldings);
            _this.assestChartOne.allocationData.push(assetObject.chartOne.directRealEstate);
            _this.assestChartOne.allocationData.push(assetObject.chartOne.directBondInvestments);
            _this.assestChartOne.allocationData.push(assetObject.chartOne.loans);
            _this.assestChartOne.allocationData.push(assetObject.chartOne.equities);
            _this.assestChartOne.allocationData.push(assetObject.chartOne.fixedAssets);

            _this.assestChartOne.allocationData.push(assetObject.chartOne.cashAndEquivalent);
            _this.assestChartOne.allocationData.push(assetObject.chartOne.debentures);

            _this.assestChartOne.allocationData.push(assetObject.chartOne.financialInstitutionsReceivables);
            _this.assestChartOne.allocationData.push(assetObject.chartOne.customersReceivables);

            _this.assestChartOne.allocationData.push(assetObject.chartOne.equipment);
            _this.assestChartOne.allocationData.push(assetObject.chartOne.reserves);
            _this.assestChartOne.allocationData.push(assetObject.chartOne.administrativeAssets);
            _this.assestChartOne.allocationData.push(assetObject.chartOne.retirementProvisions);
            _this.assestChartOne.allocationData.push(assetObject.chartOne.others);
        };

        this.assestChartTwo = {};
        this.assestChartTwo.allocationLabels = [$filter('translate')('ALTERNATIVES'), $filter('translate')('REAL_ESTATE'), $filter('translate')('BOND_INVESTMENTS'), $filter('translate')('LOANS'), $filter('translate')('EQUITIES/STOCKS'), $filter('translate')('PRIVATE_EQUITY'), $filter('translate')('PRIVATE_DEBT'), $filter('translate')('HEDGE_FUNDS'), $filter('translate')('REAL_ASSETS'), $filter('translate')('MIXED_INVESTMENTS_DETAILS'), $filter('translate')('CASH_EQUIVALENTS'), $filter('translate')('INVESTMENTS_IN_AFFILIATED_COMPANIES'), $filter('translate')('INSURANCE_CONTRACTS')];
        this.assestChartTwo.allocationColors = ['#B2182B', '#EF8A62', '#FDDBC7', '#D1E5F0', '#67A9CF', '#80568B', '#1A3C4F', '#0D6090', '#6B2720', '#718E6B', '#B69355', '#4ED920', '#414833'];

        this.assestChartTwo.allocationOptions = {
            tooltips: {
                enabled: false,
                tooltipTemplate: '<%= value %>%',
                position: 'nearest',
                custom: function custom(tooltip) {
                    // Tooltip Element
                    var tooltipEl = document.getElementsByClassName('asset-chart-two')[0].parentElement;

                    //Hide if no tooltip
                    if (tooltip.opacity === 0) {
                        tooltipEl.style.opacity = 0;
                        return;
                    }

                    function getBody(bodyItem) {
                        return bodyItem.lines;
                    }

                    // Set Text
                    if (tooltip.body) {
                        var bodyLines = tooltip.body.map(getBody);
                        var innerHtml = '<thead>';
                        innerHtml += '</thead><tbody>';
                        bodyLines.forEach(function (body, i) {
                            var values = body[0].split(': ');
                            var label = values[0] + ': ' + values[1] + '%';
                            innerHtml += '<tr><td>' + label + '</td></tr>';
                        });
                        innerHtml += '</tbody>';

                        var tableRoot = tooltipEl.querySelector('table');
                        tableRoot.innerHTML = innerHtml;
                    }

                    var positionY = this._chart.canvas.offsetTop;
                    var positionX = this._chart.canvas.offsetLeft;

                    // Display, position, and set styles for font
                    tooltipEl.style.opacity = 1;
                    if (window.innerWidth <= 350) {
                        tooltipEl.style.left = positionX + tooltip.x / 4 + 'px';
                    } else {
                        tooltipEl.style.left = positionX + tooltip.x + 'px';
                    }

                    tooltipEl.style.top = positionY + tooltip.y + 'px';
                    tooltipEl.style.fontFamily = tooltip._bodyFontFamily;
                    tooltipEl.style.fontSize = tooltip.bodyFontSize + 'px';
                    tooltipEl.style.fontStyle = tooltip._bodyFontStyle;
                    tooltipEl.style.padding = tooltip.yPadding + 'px ' + tooltip.xPadding + 'px';
                }
            }
        };

        this.assestChartOne = {};
        this.assestChartOne.allocationLabels = [$filter('translate')('SHAREHOLDINGS'), $filter('translate')('DIRECT_REAL_ESTATE'), $filter('translate')('DIRECT_BOND_INVESTMENTS'), $filter('translate')('LOANS'), $filter('translate')('EQUITIES/STOCKS'), $filter('translate')('FIXED_ASSETS'), $filter('translate')('CASH_EQUIVALENTS'), $filter('translate')('DEBENTURES'), $filter('translate')('RECEIVABLES_FINANCIAL_DETAILS'), $filter('translate')('RECEIVABLES_CUSTOMERS_DETAILS'), $filter('translate')('EQUIPMENT'), $filter('translate')('RESERVES'), $filter('translate')('ADMINISTRATIVE_ASSETS'), $filter('translate')('RETIREMENT_PROVISIONS'), $filter('translate')('OTHER')];

        this.assestChartOne.allocationColors = ['#b2182b', '#ef8a62', '#fddbc7', '#d1e5f0', '#67a9cf', '#0d6090', '#1a3c4f', '#6b2720', '#602696', '#9043d7', '#b57ee8', '#c5b9ce', '#ddd08b', '#d7bf39', '#a08d2a'];
        this.assestChartOne.allocationOptions = {
            tooltips: {
                enabled: false,
                custom: function custom(tooltip) {
                    // Tooltip Element
                    var tooltipEl = document.getElementsByClassName('asset-chart-one')[0].parentElement;

                    //Hide if no tooltip
                    if (tooltip.opacity === 0) {
                        tooltipEl.style.opacity = 0;
                        return;
                    }

                    function getBody(bodyItem) {
                        return bodyItem.lines;
                    }

                    // Set Text
                    if (tooltip.body) {
                        var bodyLines = tooltip.body.map(getBody);
                        var innerHtml = '<thead>';
                        innerHtml += '</thead><tbody>';
                        bodyLines.forEach(function (body, i) {
                            var values = body[0].split(': ');
                            var label = values[0] + ': ' + values[1] + '%';
                            innerHtml += '<tr><td>' + label + '</td></tr>';
                        });
                        innerHtml += '</tbody>';

                        var tableRoot = tooltipEl.querySelector('table');
                        tableRoot.innerHTML = innerHtml;
                    }

                    var positionY = this._chart.canvas.offsetTop;
                    var positionX = this._chart.canvas.offsetLeft;

                    // Display, position, and set styles for font
                    tooltipEl.style.opacity = 1;

                    if (window.innerWidth <= 350) {
                        tooltipEl.style.left = positionX + tooltip.x / 4 + 'px';
                    } else {
                        tooltipEl.style.left = positionX + tooltip.x + 'px';
                    }
                    tooltipEl.style.top = positionY + tooltip.y + 'px';
                    tooltipEl.style.fontFamily = tooltip._bodyFontFamily;
                    tooltipEl.style.fontSize = tooltip.bodyFontSize + 'px';
                    tooltipEl.style.fontStyle = tooltip._bodyFontStyle;
                    tooltipEl.style.padding = tooltip.yPadding + 'px ' + tooltip.xPadding + 'px';
                }
            }
        };

        this.changeYear = function (asset) {
            _this.assetData.map(function (c) {
                return c.highlight = false;
            });
            asset.highlight = true;
            _this.assetObject = asset;

            _this.setChartData(asset);
        };
        this.toggleAssetAllocation = function () {
            _this.$ionicScrollDelegate.resize();
            _this.showAssetAllocation = !_this.showAssetAllocation;
        };
    }
};

exports.default = assetAllocation;


/** WEBPACK FOOTER **
 ** ./src/app/directives/assetAllocation/assetAllocation.js
 **/